var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.002,
    height: 20.998,
    viewBox: "0 0 21.002 20.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0,
    y2: 0.243,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M17124.148-166a3.15,3.15,0,0,1-3.148-3.149V-176.5a3.15,3.15,0,0,1,3.148-3.149h9.451a3.148,3.148,0,0,1,3.1,2.667l3.859-1.54a1.047,1.047,0,0,1,.98.1,1.045,1.045,0,0,1,.461.869v9.452a1.045,1.045,0,0,1-.461.869,1.06,1.06,0,0,1-.98.108l-3.859-1.544a3.148,3.148,0,0,1-3.1,2.667Zm-1.049-10.5v7.352a1.051,1.051,0,0,0,1.049,1.05h9.451a1.048,1.048,0,0,0,1.051-1.05V-176.5a1.048,1.048,0,0,0-1.051-1.05h-9.451A1.051,1.051,0,0,0,17123.1-176.5Zm13.654,1.76v3.829l3.148,1.26V-176Zm-6.932-6.264a1.353,1.353,0,0,0-1.889,0,1.039,1.039,0,0,1-1.035.305,1.049,1.049,0,0,1-.758-.77,1.055,1.055,0,0,1,.322-1.028,3.458,3.458,0,0,1,4.832,0,1.055,1.055,0,0,1,.322,1.028,1.059,1.059,0,0,1-.758.77,1.039,1.039,0,0,1-.266.035A1.044,1.044,0,0,1,17129.822-181.006Zm2.521-2.487a4.954,4.954,0,0,0-6.93,0,1.052,1.052,0,0,1-1.451-.047,1.051,1.051,0,0,1-.021-1.445,7.054,7.054,0,0,1,9.869,0,1.04,1.04,0,0,1-.021,1.445,1.039,1.039,0,0,1-.748.315A1.042,1.042,0,0,1,17132.344-183.492Z",
    transform: "translate(-17121 186.998)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolive);
export default __webpack_public_path__ + "static/media/golive.c5234a0c5cd04061430ff5065602c61b.svg";
export { ForwardRef as ReactComponent };